module.exports = __webpack_public_path__ + "static/media/Kimberly P.13942b27.jpg";